import api from '@/api';
import eventBus, { EventType } from '@/eventBus';
import { UserType } from "@/models/User";
import { AppState, AuthData, AuthPayload, FormulasState, TestState, User } from "@/store/types";
import { FormulaDef, RecordSet, SearchCampaignForm, SearchFormulaForm, SearchSmartProfileForm, SearchTestResultForm, SearchUserForm, TestInstance } from '@/types';
import { parseJwtPayload } from "@/utils";
import Vue from "vue";
import Vuex from "vuex";
import dateFormat from "dateformat";
import { Campaign } from '@/models/Campaign';
import { SmartProfile } from '@/models/SmartProfile';
import { SmartSearch, SmartSearchFilterForm } from '../models/SmartSearch';

Vue.use(Vuex);
let authTimeout: number;
const store: any = new Vuex.Store({
  state: {
    publicPath: process.env.BASE_URL,
    auth: null,
    lastInteractionAt: 0,
    locale: "it",
    labels: {
      "invalid-request": "Operazione non valida",
      "url-expired": "Link scaduto",
      "page-companies-title": "Elenco Aziende/Gruppi",
      "page-campaigns-title": "Elenco Campagne",
      "page-campaign-title": "Campagna",
      "page-resetPassword-title": "Nuova password",
      "page-company-title": "Dettaglio Azienda",
      "page-users-title": "Elenco Utenti",
      "page-user-title": "Dettaglio Utente",
      "page-home-title-m": "Benvenuto",
      "page-home-title-f": "Benvenuta",
      "page-formulas-title": "Configurazione Formule",
      "page-smartProfiles-title": "Profili Smart",
      "page-smartProfile-title": "Profilo Smart",
      "page-smartSearches-title": "Lista Ricerche Smart",
      "page-smartSearch-title": "Ricerca Smart",
      "page-test-title": "Test ${name}",
      "page-testResults-title": "Risultati Utenti",
      "page-testResult-title": "Esito Test",
      "page-forgotPassword-title": "Password Dimenticata",
      "page-enroll-title": "Registrati",
      "message-smartProfile-confirm-delete": "Sei sicuro di voler eliminare il profilo \"${name}\"?",
      "message-company-confirm-delete": "Sei sicuro di voler eliminare l'azienda \"${name}\"?",
      "message-user-confirm-delete": "Sei sicuro di voler eliminare l'utente \"${name}\"?",
      "message-campaign-confirm-delete": "Sei sicuro di voler eliminare la campagna \"${name}\"",
      "message-company-limit": "ed altre ${count}",
      "message-limit": "ed altri ${count} elementi",
      "message-query-result-count": "Trovati: ${count}",
      "message-test-responses": "Risposte: ${r} di ${q}",
      "message-session-expiring": "La tua sessione scadrà tra ${time} secondi per inattività. Vuoi rimanere connesso?",
      "message-test-completed": "Congratulazioni hai risposto a tutte le domande! Clicca \"Completa\" per concludere il test.",
      "message-formula-confirm-delete": "Sei sicuro di voler eliminare la formula \"${formula}\"?",
      "message-forgotPassword-sent": "Email per il reset della password inviata. Controlla la tua casella di posta elettronica",
      "label-stayConnected": "Rimani connesso",
      "title-session-expiring": "Scadenza sessione",
      "title-status": "Status",
      "title-test-completed": "Test Completato",
      "title-invite": "Invita",
      "format-date-full": "dd/mm/yyyy HH:MM:ss",
      "format-date-month": "dd mmmm yyyy",
      "label-invite": "Invita",
      "label-emails": "Email",
      "label-emails-placeholder": "email separate da virgola, punto e virgola, spazio o invio",
      "label-send": "Invia",
      "label-ok": "Ok",
      "label-forgotPassword": "Password dimenticata?",
      "label-print-result": "Esito dell'analisi",
      "label-print-profile": "Profilo di",
      "label-print-profile2": "Profilo",
      "label-print-profile3": "Emergono i seguenti punti",
      "label-report-results": "Risultati Utenti",
      "label-tests-none": "Nessun test disponibile",
      "label-smartProfiles-none": "Nessun profilo smart disponibile",
      "label-smartProfile-placeholder": "Profilo Smart...",
      "label-smartProfile": "Profilo Smart",
      "label-smartProfiles": "Profili Smart",
      "label-smartSearches-none": "Nessun ricerca smart trovata",
      "label-smartSearches-new": "Nuova Ricerca Smart",
      "label-smartSearches": "Ricerca Smart",
      "label-parameters-none": "Nessun parametro inserito",
      "label-recalculate": "Ricalcola",
      "label-yes": "Si",
      "label-no": "No",
      "label-noDataAvailable": "Nessun Dato Disponibile",
      "label-min": "Minimo",
      "label-max": "Massimo",
      "label-add": "Aggiungi",
      "label-weight": "Peso",
      "label-login": "Login",
      "label-user": "Utente",
      "label-goTo-test": "Vai al test",
      "label-conclusions": "Conclusioni",
      "label-date": "Data",
      "label-signature": "Firma",
      "label-calculate": "Calcola",
      "label-summary": "Riepilogo",
      "label-later": "Più tardi",
      "label-next": "Avanti",
      "label-complete": "Completa",
      "label-previous": "Indietro",
      "label-search": "Ricerca",
      "label-noOptions": "Nessun risultato",
      "label-noResult": "Nessun risultato",
      "label-action-select": "Premi invio per selezionare",
      "label-action-deselect": "Premi invio per deselezionare",
      "label-selected": "Selezionata",
      "label-company-new": "Nuova Azienda",
      "label-smartProfiles-new": "Nuovo Profilo Smart",
      "label-users-new": "Nuovo Utente",
      "label-campaigns-new": "Nuova Campagna",
      "label-campaigns-none": "Nessuna campagna trovata",
      "label-formula-new": "Nuova Formula",
      "label-formula": "Formula",
      "label-userType": "Ruolo",
      "label-company-name": "Ragione Sociale",
      "label-company-numTests": "Test Assegnabili",
      "label-company-piva": "P. IVA",
      "label-company": "Azienda",
      "label-companies": "Aziende",
      "label-actions": "Azioni",
      "label-address": "Indirizzo",
      "label-city": "Città",
      "label-postalCode": "CAP",
      "label-phone": "Telefono",
      "label-mobilePhone": "Cellulare",
      "label-fullName": "Nome Completo",
      "label-filters": "Filtri",
      "label-parameters": "Parametri",
      "label-category": "Categoria",
      "label-all": "Tutti",
      "label-name": "Nome",
      "label-company-placeholder": "Cerca Azienda...",
      "label-username": "Username",
      "label-surname": "Cognome",
      "label-score": "Punteggio",
      "label-param": "Parametro",
      "label-value": "Valore",
      "label-negative": "Negativo",
      "label-positive": "Positivo",
      "label-factor": "Peso",
      "label-campaign": "Campagna",
      "label-campaign-placeholder": "Cerca Campagna...",
      "label-includeNoCampaign": "Includi test senza campagna",
      "label-dateTime": "Data/Ora",
      "label-gender": "Sesso",
      "label-flags": "Flags",
      "label-active": "Attivo",
      "label-inactiveOnly": "Solo Non Attivo",
      "label-noCompany": "Senza Azienda",
      "label-report": "Report",
      "label-comments": "Commenti",
      "label-hired": "Assunto",
      "label-dateBirth": "Data di Nascita",
      "label-dateBirth-placeholder": "AAAA-MM-GG",
      "label-email": "Email",
      "label-save": "Salva",
      "label-cancel": "Annulla",
      "label-logout": "Disconnetti",
      "label-password": "Password",
      "label-confirmPassword": "Conferema Password",
      "label-registry": "Anagrafica",
      "label-registry-companies": "Aziende/Gruppi",
      "label-registry-users": "Utenti",
      "label-registry-campaigns": "Campagne",
      "label-configuration": "Configurazione",
      "label-configuration-formulas": "Formule Esito",
      "label-configuration-smartProfiles": "Profili Smart",
      "label-test": "Test",
      "label-test-placeholder": "Test...",
      "label-assignDate": "Data Asseg.",
      "label-creationDate": "Data Creaz.",
      "label-startDate": "Data Inizio",
      "label-endDate": "Data Fine",
      "label-status": "Stato",
      "label-validity": "Validità",
      "label-group": "Gruppo",
      "label-content": "Contenuto",
      "label-tests": "Test",
      "label-notAvilable": "ND",
      "select-gender-m": "Maschile",
      "select-gender-f": "Femminile",
      "label-results-none": "Nessun risultato trovato",
      "select-userType-USER": "Utente",
      "select-userType-LEADER": "Leader",
      "select-userType-ADMIN": "Admin",
      "select-userType-SUPERADMIN": "Super Admin",
      "select-testStatus-CREATED": "Creato",
      "select-testStatus-STARTED": "Iniziato",
      "select-testStatus-COMPLETED": "Concluso",
      "select-testStatus-VERIFIED": "Verificato",
      "label-smart-search-filter-all": "Tutti",
      "label-smart-search-filter-full": "Solo Conformi",
      "label-smart-search-filter-partial": "Solo Non Conformi",
      "label-campaigns": "Campagne",
      "label-incNoCampaing": "Inc. Senza Camp.",
      "message-smartSearch-confirm-delete": "sei sicuro di voler eliminare la ricerca del ${createdAt}",
      "label-order-asc": "Crescente",
      "label-order-desc": "Decrescente",
      "label-userType-all": "Tutti i ruoli",
      "label-companies-none": "Nessun azienda trovata",
      "label-users-none": "Nessun utente trovato",
      "label-test-none": "Nessun test trovato",
      "label-site": "www.qube.it",
      "validation-name-required": "Il nome è richiesto",
      "validation-username-required": "Lo username è richiesto",
      "validation-username-format": "Può contentere solo lettere non accentate, numeri, trattino (-) o trattino basso(_). Deve iniziare per lettera",
      "validation-password-required": "La password è richiesta",
      "validation-password-weak": "La password deve contenere lettere maiuscole, minuscole, numeri e caratteri speciali",
      "validation-confirmPassword-notMatch": "Le password non coincidono",
      "validation-email-format": "Email non valida",
      "validation-email-exists": "L'email è usata da un altro utente",
      "validation-phone": "Telefono non valido",
      "validation-length-3": "Lunghezza minima 3 caratteri",
      "validation-length-8": "Lunghezza minima 8 caratteri",
      "validation-company-name-exists": "L'azienda \"${name}\" esiste già",
      "validation-link-invalid-expired": "Link non valido o scaduto",
      "validation-company-required": "Il campo azienda è richiesto",
      "validation-company-invalid": "L'azienda selezionata non è valida",
      "validation-test-required": "Il campo test è richiesto",
      "validation-smartProfile-esists": "Questo profilo esiste già",
      "label-smartProfile-parameters": "Parametri Profilo Smart",
      "error-not-found": "Elemento non trovato",
      "generic-server-error": "Errore Server",
      "user-not-found": "Utente non trovato",
      "title-delete": "Elimina",
      "label-privacy": "Privacy",
      "label-decline": "Rifuta",
      "label-accept": "Accetta",
      "label-invites": "Inviti",
      "label-completed": "Completati",
      "format-day-sun-short": "Dom",
      "format-day-mon-short": "Lun",
      "format-day-tue-short": "Mar",
      "format-day-wed-short": "Mer",
      "format-day-thu-short": "Gio",
      "format-day-fri-short": "Ven",
      "format-day-sat-short": "Sab",
      "format-day-sun-full": "Lunedì",
      "format-day-mon-full": "Martedì",
      "format-day-tue-full": "Mercoledì",
      "format-day-wed-full": "Mercoledì",
      "format-day-thu-full": "Giovedì",
      "format-day-fri-full": "Venerdì",
      "format-day-sat-full": "Sabato",
      "format-month-jan-short": "Gen",
      "format-month-feb-short": "Feb",
      "format-month-mar-short": "Mar",
      "format-month-apr-short": "Apr",
      "format-month-may-short": "Mag",
      "format-month-jun-short": "Giu",
      "format-month-jul-short": "Lug",
      "format-month-aug-short": "Ago",
      "format-month-sep-short": "Set",
      "format-month-oct-short": "Ott",
      "format-month-nov-short": "Nov",
      "format-month-dic-short": "Dic",
      "format-month-jan-full": "Gennaio",
      "format-month-feb-full": "Febbraio",
      "format-month-mar-full": "Marzo",
      "format-month-apr-full": "Aprile",
      "format-month-may-full": "Maggio",
      "format-month-jun-full": "Giugno",
      "format-month-jul-full": "Luglio",
      "format-month-aug-full": "Agosto",
      "format-month-sep-full": "Settembre",
      "format-month-oct-full": "Ottobre",
      "format-month-nov-full": "Novembre",
      "format-month-dic-full": "Dicembre",
      "format-time-a": "a",
      "format-time-p": "p",
      "format-time-am": "am",
      "format-time-pm": "pm",
      "format-time-A": "A",
      "format-time-P": "P",
      "format-time-AM": "AM",
      "format-time-PM": "PM",
      "html-privacy": "<div><span style=\"font-weight: bold;\">TRATTAMENTO E PROTEZIONE DEI DATI PERSONALI</span></div><div><span style=\"font-weight: bold;\"><br /></span></div><div><br /></div><div>Ai sensi dell'art. 12</div>",
      "html-privacy2": "<p><strong><span class=\"block text-center\">INFORMATIVA E CONSENSO AL TRATTAMENTO DEI DATI PERSONALI E SENSIBILI</span></strong></p>\n          <p><span class=\"block text-justify\">Il Decreto Legislativo n. 196 del 30/06/2003, \"Codice in materia di protezione dei dati personali\", \n          nel disciplinare il diritto alla riservatezza ha previsto che la raccolta ed il trattamento di dati personali di qualsiasi tipo in banche dati, \n          sia elettroniche che artacee, debba essere preceduto dalla prescritta informativa e, nei casi in cui è richiesto, dal consenso espresso della \n          persona alla quale i dati si riferiscono.</span></p>\n          <p><span class=\"block text-justify\">Tutte le informazioni raccolte nonché quelle che emergono o potrebbero emergere ai fini dell’espletamento delle \n          attività della Qube Consulting S.r.l., come indicate di seguito al paragrafo a), saranno trattate in conformità alle norme per la tutela delle \n          persone rispetto al trattamento dei dati personali (Decreto Legislativo 196/03 e sue successive modificazioni ed integrazioni).</span></p>\n          <p>In particolare, Le chiediamo di tenere conto di quanto segue:</p>\n          <p><strong>a) Finalità e modalità del trattamento</strong></p>\n          <p><span class=\"block text-justify\">I Suoi dati personali risultano indispensabili per esperire gli adempimenti connessi alle attività della Qube \n          Consulting S.r.l, società che si occupa di fornire servizi di consulenza organizzativa, coaching, formazione e selezione, e saranno trattati ed archiviati, \n          in forma cartacea e/o informatizzata, per l’esclusiva finalità connessa alle attività suindicate.</span></p>\n          <p><strong>b) Ambito di comunicazione e diffusione</strong></p>\n          <p><span class=\"block text-justify\">I dati personali saranno resi disponibili alla Qube Consulting S.r.l. ed ai Soggetti/Enti a diverso titolo coinvolti \n          nell’intervento consulenziale specifico richiesto.</span></p>\n          <p><strong>c) Diritti dell’interessato</strong></p>\n          <p>Lei potrà, in qualsiasi momento, avvalersi della facoltà di:</p>\n          <ul>\n            <li><p>essere informato con riferimento al Titolare, al Responsabile, delle modalità e finalità del trattamento</p></li>\n            <li><p>ottenere, a cura del Titolare o del Responsabile del trattamento, la conferma dell’esistenza e la comunicazione  di dati personali che la riguardano, \n            la cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in violazione di legge, l’aggiornamento, la rettifica e l’integrazione \n            dei dati.</p></li>\n            <li><p>opporsi, per motivi legittimi, al trattamento dei dati.</p></li>\n          </ul>\n          <p><strong>d) Titolare e Responsabile del trattamento dei dati</strong></p>\n          <p>Il Titolare del trattamento è la Qube Consulting S.r.l. con sede in Roma – Viale dell’Università, n. 25.</p>\n          <p></p>\n          <p><strong><span class=\"block text-center\">CONSENSO AL TRATTAMENTO DEI DATI PERSONALI/SENSIBILI</span></strong></p>\n          <p><span class=\"block text-justify\">Io sottoscritto ${user.name} ${user.surname} con riferimento all'informativa ricevuta, avendo preso atto che ai fini \n          dell’espletamento dell’attività consulenziale proposta, è necessario il trattamento da parte della Qube Consulting S.r.l dei miei dati personali:</span></p>\n          <p><span class=\"block text-justify\">AUTORIZZO LA QUBE CONSULTING S.R.L. al trattamento dei dati personali/sensibili ai sensi del Decreto Legislativo n.196/03 \n          e sue successive modificazioni ed integrazioni.</span></p>\n          <p><span class=\"block text-justify\">Dichiaro che mi sono state preventivamente rese, con la nota informativa di cui sopra che si considera parte integrante e \n          sostanziale della presente dichiarazione, le prescritte informazioni circa le caratteristiche, finalità, modalità del trattamento, comunicazione e diffusione \n          dei dati.</span></p>"
    },
    usersSearch: {
      surname: "",
      name: "",
      type: "",
      companies: [],
      inactiveOnly: false,
      noCompany: false
    } as SearchUserForm,
    usersResult: {
      page: 1,
      pageSize: 1,
      total: 0,
      records: []
    } as RecordSet<User>,
    smartProfilesResult: {
      form: {
        name: "",
        company: undefined,
        testDef: undefined
      } as SearchSmartProfileForm,
      data: {
        page: 1,
        pageSize: 1,
        total: 0,
        records: []
      } as RecordSet<SmartProfile>,
    },
    smartSearchesResult: {
      form: {
        companies: [],
        smartProfile: undefined
      } as SmartSearchFilterForm,
      data: {
        page: 1,
        pageSize: 1,
        total: 0,
        records: []
      } as RecordSet<SmartSearch>
    },
    testResults: {
      form: {
        surname: "",
        name: "",
        companies: [],
        order: -1
      },
      data: {
        page: 1,
        pageSize: 1,
        records: [],
        total: 0
      }
    },
    test: undefined,
    formulas: {
      form: {
        testDef: undefined
      }
    },
    campaignResults: {
      form: {
        name: "",
        company: undefined
      },
      data: {
        page: 1,
        pageSize: 1,
        records: [],
        total: 0
      }
    }
  } as AppState,
  mutations: {
    auth(state, auth: AuthData | null) {
      state.auth = auth;
    },
    lastInteractionAt(state, lastInteractionAt = 0) {
      state.lastInteractionAt = lastInteractionAt;
    },
    usersSearch(state, usersSearch: SearchUserForm) {
      state.usersSearch = usersSearch
    },
    usersResult(state, usersResult: RecordSet<User>) {
      state.usersResult = usersResult
    },
    testState(state, testState: TestState) {
      state.test = testState
    },
    formulasState(state, formulasState: FormulasState) {
      state.formulas = formulasState
    },
    testInstance(state, instance: TestInstance) {
      if (state.test) state.test.instance = instance;
    },
    editFormula(state, formula: FormulaDef) {
      state.formulas.formula = formula;
    },
    testResultsForm(state, form: SearchTestResultForm) {
      state.testResults.form = form;
    },
    testResultsData(state, data: RecordSet<TestInstance>) {
      state.testResults.data = data;
    },
    campaignResultsForm(state, form: SearchCampaignForm) {
      state.campaignResults.form = form;
    },
    campaignResultsData(state, data: RecordSet<Campaign>) {
      state.campaignResults.data = data;
    }
  },
  getters: {
    accessToken(state): string {
      return state.auth ? state.auth.accessToken : "";
    },
    publicPath(state): string {
      return state.publicPath ? state.publicPath : "";
    },
    user(state): AuthPayload | null {
      return state.auth ? state.auth.payload : null;
    },
    isSuperAdmin(state, getters) {
      const user = getters.user;
      return user && user.type === UserType.SUPERADMIN;
    },
    isAtLeastAdmin(state, getters) {
      const user = getters.user;
      return (
        user &&
        (user.type === UserType.SUPERADMIN || user.type === UserType.ADMIN)
      );
    },
    isAtLeastLeader(state, getters) {
      const user = getters.user;
      return (
        user &&
        (user.type === UserType.SUPERADMIN ||
          user.type === UserType.ADMIN ||
          user.type === UserType.LEADER)
      );
    },
    isUser(state, getters) {
      const user = getters.user;
      return user && user.type === UserType.USER;
    },
    auth(state): AuthData | null {
      return state.auth;
    },
    usersSearch(state) {
      return state.usersSearch;
    },
    usersResult(state) {
      return state.usersResult;
    },
    test(state) {
      return state.test;
    },
    testResultsData(state) {
      return state.testResults.data
    },
    testResultsForm(state) {
      return state.testResults.form
    },
    canDoReport(state, getters) {
      const user = getters.user as User;
      if (!user) return false;
      if (!getters.isAtLeastLeader) return false;
      if (user.type === UserType.LEADER && !user.report) return false;
      return true
    }
  },
  actions: {
    /**
     * Updates the auth entirely (accessToken and payload)
     * @param context
     * @param auth
     */
    auth(context, auth: AuthData) {
      if (auth) {
        localStorage.setItem("auth", JSON.stringify(auth));
        const now = Math.floor(Date.now() / 1000);
        const diff = auth.payload.exp - now;
        if (diff < 60 && diff > 0) {
          context.dispatch("refreshAuth");
          return;
        }
        console.log("Session exipres in " + diff + "sec")
        if (authTimeout) clearTimeout(authTimeout);
        authTimeout = setTimeout(() => {
          if (!context.state.auth) return;
          const now = Math.floor(Date.now() / 1000);
          const diff = now - context.state.lastInteractionAt;
          const sessionTimeout = parseInt(process.env.VUE_APP_SESSION_TIMEOUT || "30")
          if (diff <= 0) return;
          if (diff >= sessionTimeout) {
            eventBus.$emit(EventType.SESSION_EXPIRING, 60);
            authTimeout = setTimeout(() => {
              context.dispatch("logout")
            }, 60000)
          } else context.dispatch("refreshAuth")
        }, (diff - 60) * 1000);
      } else {
        localStorage.removeItem("auth");
        if (authTimeout) clearTimeout(authTimeout);
      }
      context.commit("auth", auth);
    },
    /**
     *
     * @param context clear the auth
     */
    logout(context) {
      context.dispatch("auth", null);
      eventBus.$emit(EventType.LOGOUT);
    },
    /**
     * Sets the access token, it will update the payload as well
     * @param context
     * @param token
     */
    accessToken(context, token) {
      const payload: AuthPayload = parseJwtPayload(token);
      context.dispatch("auth", { payload: payload, accessToken: token });
    },

    /**
     * Sets the access token, the refresh token and it will update the payload as well
     * @param context
     * @param response authentication response {accessToken, refreshToken}
     */
    loginResponse(context, response) {
      const payload: AuthPayload = parseJwtPayload(response.accessToken);
      context.dispatch("auth", { payload: payload, accessToken: response.accessToken, refreshToken: response.refreshToken });
    },
    /**
     * Uses the refresh token to refresh the auth data
     * @param context 
     */
    refreshAuth(context) {
      if (context.state.auth) {
        return api.auth.refresh(context.state.auth.refreshToken).then((authData: any) => {
          context.dispatch("loginResponse", authData);
        }).catch((err: any) => {
          console.error("Refresh Token Error", err);
          this.dispatch("auth", null);
        });
      }
    },
    /**
     * sets last interaction to now
     * @param context 
     */
    interaction(context) {
      const sec = Math.floor(Date.now() / 1000);
      this.commit("lastInteractionAt", sec);
    },
    /**
     * Sets the users Search Form
     */
    usersSearch(context, usersSearch: SearchUserForm) {
      context.commit("usersSearch", usersSearch)
    },
    /**
     * Sets the users Result
     */
    usersResult(context, usersResult: RecordSet<User>) {
      context.commit("usersResult", usersResult)
      context.dispatch("interaction");
    },
    /**
     * Sets the test entire state
     * @param context store context
     * @param testState test state
     */
    testState(context, testState: TestState) {
      context.commit("testState", testState);
    },
    /**
     * Sets the formulas entire state
     * @param context store context
     * @param formulasState formulas state
     */
    formulasState(context, formulasState: FormulasState) {
      context.commit("formulasState", formulasState);
    },
    async loadTest(context, id) {
      const instance = await api.testInstances.get(id);
      const def = await api.testDefs.get(instance.testDef._id);
      const localeStr = def.locales.includes(context.state.locale) ? context.state.locale : def.locales[0];
      const locale = await api.testLocales.get(def._id, localeStr);
      this.dispatch("testState", { instance, def, locale, showCompleteOnSummary: false } as TestState);
    },
    async loadFormulas(context, id) {
      const form = context.state.formulas.form;
      if (id) {
        const def = await api.testDefs.get(id);
        const localeStr = def.locales.includes(context.state.locale) ? context.state.locale : def.locales[0];
        const locale = await api.testLocales.get(def._id, localeStr);
        this.dispatch("formulasState", { form, def, locale });
      } else {
        this.dispatch("formulasState", { form, def: null, locale: null });
      }
    },
    editFormula(context, formula: FormulaDef) {
      context.commit("editFormula", formula)
    },
    testResultsForm(context, form: SearchTestResultForm) {
      context.commit("testResultsForm", form);
      context.dispatch("interaction");
    },
    testResultsData(context, data: RecordSet<TestInstance>) {
      context.commit("testResultsData", data)
      context.dispatch("interaction");
    },
    campaignResultsForm(context, data: SearchCampaignForm) {
      context.commit("campaignResultsForm", data)
      context.dispatch("interaction");
    },
    campaignResultsData(context, data: RecordSet<Campaign>) {
      context.commit("campaignResultsData", data)
      context.dispatch("interaction");
    }
  },
  modules: {}
});

const authStr = window.localStorage.getItem("auth");
let initialAuth: AuthData | null = authStr ? JSON.parse(authStr) : null;
const now = Math.floor(Date.now() / 1000);
if (initialAuth && initialAuth.payload.exp <= now) {
  window.localStorage.removeItem("auth");
  initialAuth = null;
}
store.dispatch("auth", initialAuth);

dateFormat.i18n = {
  dayNames: [
    store.state.labels["format-day-sun-short"],
    store.state.labels["format-day-mon-short"],
    store.state.labels["format-day-tue-short"],
    store.state.labels["format-day-wed-short"],
    store.state.labels["format-day-thu-short"],
    store.state.labels["format-day-fri-short"],
    store.state.labels["format-day-sat-short"],
    store.state.labels["format-day-sun-full"],
    store.state.labels["format-day-mon-full"],
    store.state.labels["format-day-tue-full"],
    store.state.labels["format-day-wed-full"],
    store.state.labels["format-day-thu-full"],
    store.state.labels["format-day-fri-full"],
    store.state.labels["format-day-sat-full"],
  ],
  monthNames: [
    store.state.labels["format-month-jan-short"],
    store.state.labels["format-month-feb-short"],
    store.state.labels["format-month-mar-short"],
    store.state.labels["format-month-apr-short"],
    store.state.labels["format-month-may-short"],
    store.state.labels["format-month-jun-short"],
    store.state.labels["format-month-jul-short"],
    store.state.labels["format-month-aug-short"],
    store.state.labels["format-month-sep-short"],
    store.state.labels["format-month-oct-short"],
    store.state.labels["format-month-nov-short"],
    store.state.labels["format-month-dic-short"],
    store.state.labels["format-month-jan-full"],
    store.state.labels["format-month-feb-full"],
    store.state.labels["format-month-mar-full"],
    store.state.labels["format-month-apr-full"],
    store.state.labels["format-month-may-full"],
    store.state.labels["format-month-jun-full"],
    store.state.labels["format-month-jul-full"],
    store.state.labels["format-month-aug-full"],
    store.state.labels["format-month-sep-full"],
    store.state.labels["format-month-oct-full"],
    store.state.labels["format-month-nov-full"],
    store.state.labels["format-month-dic-full"],
  ],
  timeNames: [
    store.state.labels["format-time-a"],
    store.state.labels["format-time-p"],
    store.state.labels["format-time-am"],
    store.state.labels["format-time-pm"],
    store.state.labels["format-time-A"],
    store.state.labels["format-time-P"],
    store.state.labels["format-time-AM"],
    store.state.labels["format-time-PM"]
  ],
};

export default store;